import { gql } from '@apollo/client';

const RESET_USER_PASSWORD_MUTATION = gql`
  mutation resetUserPassword($input: ResetUserPasswordInput) {
    resetUserPasswordResult: resetUserPassword(input: $input) {
      result {
        result
        extras
      }
    }
  }
`;

export default RESET_USER_PASSWORD_MUTATION;
